import React, {Component} from 'react';
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import Checkbox from "@amzn/meridian/checkbox";
import ControlGroup from "@amzn/meridian/control-group";
import {optionsAddedOrChanged} from "../../actions/OptionsActions";
import {FormattedMessage} from "react-intl";
import {Capability} from "../../enums";

class ClusterOptions extends Component {
    render() {

        const {allClusters, selectedClusters} = this.props;
        const {textId, defaultMessage} = this.getTextDetails()
        return (
            <ControlGroup label={<FormattedMessage id={textId} defaultMessage={defaultMessage}/>}
                          onChange={updatedClusters => this.handleClustersChange(updatedClusters)} value={selectedClusters}>
                {allClusters.sort().map(cluster => (
                    <Checkbox key={cluster} value={cluster} data-cy={"clusterFieldsetOption"}>{cluster}</Checkbox>
                ))}
            </ControlGroup>
        )
    }

    getTextDetails() {
        if(Capability.SSD === this.props.capability) {
            return {
                textId: "zoneOptions.zone",
                defaultMessage: "Zone"
            }
        }
        return {
            textId: "clusterOptions.cluster",
            defaultMessage: "Cluster"
        }
    }

    handleClustersChange(updatedClusters) {
        this.props.dispatch(optionsAddedOrChanged(
            {
                'clusters': updatedClusters
            }))
    }
}

const mapStateToProps = state => ({
    selectedClusters: state.optionsReducer.options.clusters,
    allClusters: state.optionsReducer.allClusters,
    capability: state.optionsReducer.capability
});
export default withRouter(connect(mapStateToProps)(ClusterOptions));


// WEBPACK FOOTER //
// ./src/components/options/ClusterOptions.js